import styled from 'styled-components'
import { sizes, colors } from '@theme'

export const StyledA = styled.a`
  width: 100%;

  @media screen and (min-width: ${sizes.small.min}) {
    width: auto;
  }
  @media screen and (max-width: 768px) {
    display: ${({ displayNone }) => displayNone && 'none'};
  }
`

export const EventDirections = styled.div`
  width: fit-content;
  margin-bottom: 20px;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: ${colors.gold};
  }
`
